import { cn } from '@/lib/cn';
import { getTournamentOrCategoryBadge, isFlagBadgeSrc } from '@/shell/sports-menu-utils';

export interface SearchTournamentItemProps {
  label: string;
  subtitle: string;
  tournamentName?: string;
  categoryName?: string;
  onSelect?: () => void;
  className?: string;
}

export function SearchTournamentItem({
  label,
  subtitle,
  tournamentName,
  categoryName,
  onSelect,
  className,
}: SearchTournamentItemProps) {
  const crestSrc = getTournamentOrCategoryBadge(tournamentName ?? label, categoryName ?? subtitle);

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'flex h-10 w-full items-center gap-2 bg-bg-canvas px-3 py-2 text-left',
        'hover:bg-bg-surface focus-visible:bg-bg-surface focus-visible:outline-none',
        className,
      )}
    >
      <span
        className={cn(
          'flex size-5 shrink-0 items-center justify-center overflow-clip rounded-full',
          crestSrc && !isFlagBadgeSrc(crestSrc) && 'bg-white',
        )}
      >
        {crestSrc ? (
          <img
            src={crestSrc}
            alt=""
            className={cn(
              isFlagBadgeSrc(crestSrc) ? 'size-full object-cover' : 'size-4 object-contain',
            )}
          />
        ) : (
          <span className="text-[7px] font-bold leading-none text-text-secondary">
            {label.slice(0, 2).toUpperCase()}
          </span>
        )}
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5 overflow-hidden">
        <span className="truncate text-[13px] text-text-primary">{label}</span>
        <span className="truncate text-[11px] text-text-secondary">{subtitle}</span>
      </span>
    </button>
  );
}
